<template>
  <section
    class="repair-summary"
    aria-label="Сводка по ремонтам"
  >
    <dl class="repair-summary__list">
      <div
        v-for="({ label, color, icon, value }) in metrics"
        :key="label"
        class="repair-summary__item"
        :class="`repair-summary__item--${color}`"
      >
        <dt class="repair-summary__title">
          <span class="repair-summary__metric-icon">
            <component
              :is="icon"
              :size="20"
            />
          </span>

          {{ label }}
        </dt>

        <dd class="repair-summary__value">{{ getSummary(value) }}</dd>
      </div>
    </dl>
  </section>
</template>

<script>
import {
  ClipboardList,
  Clock3,
  Wrench,
  CircleCheck
} from 'lucide-vue'

export default {
  name: 'RepairSummary',
  props: {
    data: {
      type: Array,
      default: () => []
    },
    unavailable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    metrics () {
      return [
        {
          label: 'Всего заказов',
          value: this.data.length,
          icon: ClipboardList,
          color: 'blue'
        },
        {
          label: 'Ожидают ремонта',
          value: this.count('opened'),
          icon: Clock3,
          color: 'yellow'
        },
        {
          label: 'В работе',
          value: this.count('repairInRepair'),
          icon: Wrench,
          color: 'purple'
        },
        {
          label: 'Завершены',
          value: this.count('closed'),
          icon: CircleCheck,
          color: 'green'
        }
      ]
    }
  },
  methods: {
    count (status) { return this.data.filter(row => row.repairStatus === status).length },
    getSummary (value) {
      return this.unavailable
        ? '—'
        : value
    }
  }
}
</script>

<style scoped lang="scss" src="./style.scss" />
